import { memo, useCallback } from "react";
import {
  ListingEditFormValues,
  MarketplaceData,
  MarketplaceEquipment,
  MarketplaceExtraData,
  MarketplacePayment,
  MarketplaceVehicleSpecs,
} from "../../types";
import VehicleSpecsSection from "./sections/VehicleSpecsSection";
import AdditionalDataSection from "./sections/AdditionalDataSection";
import EquipmentSection from "./sections/EquipmentSection";
import AdDataSection from "./sections/AdDataSection";
import { MarketplaceStepProps } from "./types";

const MarketplaceStep: React.FC<MarketplaceStepProps> = (props) => {
  const { formValues, setFormValues, errors } = props;
  const md: MarketplaceData = formValues.marketplaceData;

  const patchMarketplace = useCallback(
    (patch: Partial<MarketplaceData>) =>
      setFormValues((prev) => ({
        ...prev,
        marketplaceData: { ...prev.marketplaceData, ...patch },
      })),
    [setFormValues]
  );

  const handleSpecs = useCallback(
    (patch: Partial<MarketplaceVehicleSpecs>) =>
      patchMarketplace({ specs: { ...md.specs, ...patch } }),
    [md.specs, patchMarketplace]
  );
  const handleExtra = useCallback(
    (patch: Partial<MarketplaceExtraData>) =>
      patchMarketplace({ extra: { ...md.extra, ...patch } }),
    [md.extra, patchMarketplace]
  );
  const handleEquipment = useCallback(
    (patch: Partial<MarketplaceEquipment>) =>
      patchMarketplace({ equipment: { ...md.equipment, ...patch } }),
    [md.equipment, patchMarketplace]
  );
  const handlePayment = useCallback(
    (patch: Partial<MarketplacePayment>) =>
      patchMarketplace({ payment: { ...md.payment, ...patch } }),
    [md.payment, patchMarketplace]
  );

  return (
    <div className="w-full max-w-5xl mx-auto px-6 py-4">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-semibold text-slate-800">Podaci oglasa</h2>
        <p className="text-sm text-slate-500 mt-1">
          Zajednički sadržaj za sve odabrane oglasnike. Osnovne specifikacije vozila već su povučene iz sustava.
        </p>
      </div>

      <div className="flex flex-col gap-4">
        <AdDataSection
          formValues={formValues}
          setFormValues={setFormValues}
          payment={md.payment}
          onPaymentChange={handlePayment}
          errors={errors}
        />
        <VehicleSpecsSection values={md.specs} onChange={handleSpecs} />
        <AdditionalDataSection values={md.extra} onChange={handleExtra} />

        <EquipmentSection
          values={md.equipment}
          onChange={handleEquipment}
          unmatched={formValues.unmatchedEquipment}
        />
      </div>
    </div>
  );
};

export default memo(MarketplaceStep);
